
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16px","height":"2px","viewBox":"0 0 16 2","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('e-add')]),_c('g',{attrs:{"id":"Screens","stroke":"none","stroke-width":"1","fill":"currentColor","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"If-Else--Copy","transform":"translate(-957.000000, -984.000000)","fill":"#8492A6","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(950.000000, 970.000000)"}},[_c('g',{attrs:{"id":"e-add","transform":"translate(7.000000, 14.000000)"}},[_c('path',{attrs:{"d":"M15,0 L9,0 L7,0 L1,0 C0.4,0 0,0.4 0,1 C0,1.6 0.4,2 1,2 L7,2 L9,2 L15,2 C15.6,2 16,1.6 16,1 C16,0.4 15.6,0 15,0 Z","id":"Path"}})])])])])])
          )
        }
      }
    